<template>
<div class="container-fluid" >

<scanner @update="setBarcode"></scanner>

<div class="card border-primary">
<div class="card-header text-white bg-primary">
    <h4><i class="fas fa-camera mr-2" aria-hidden="true"></i>TRASFERIMENTO SMART</h4>
</div> 

 <div style="color:black" class="card-body"> 
  <div class="row">

  <div class="col-md-4">
  <form name="smart_mov" v-on:submit.prevent="submit()">

    <div class="form-row">         
            
      <div class="col-sm-6">
      <label for="exampleFormControlSelect1"><strong>Destinazione</strong></label>
          <select required class="form-control" id="to_storeId" v-model="cerca.to_storeId">
            <option v-for="(row,index) in company.stores" :key="index" v-bind:value="row.storeId">
              {{row.store}}
            </option>
          </select>
    </div>


    </div>

<!--
<button type="button"  @click="dataProduct('2003850000013')"   class="btn btn-warning mt-2 mb-2 ">
            <span class="fas fa-camera" aria-hidden="true"></span>
            TEST
</button>
-->

<div class="btn-group-vertical">
 
<button type="button"  @click="item={},msg.title=''"  data-toggle="modal"  data-target="#livestream_scanner" class="btn btn-info mt-2 ">
            <span class="fas fa-camera mr-3 " aria-hidden="true"></span>
            SCANSIONE BARCODE 
            <span v-if="bt_spinner1" class="spinner-border spinner-border-sm ml-2" role="status" aria-hidden="true"></span>
</button>
<button type="button"  @click="item={},msg.title=''"  class="btn btn-secondary mt-2 ">
            <span class="fas fa-eye-slash mr-3" aria-hidden="true"></span>
            RESET PRODOTTO    
            
</button>

<button :disabled="!item.productId" type="submit"  class="btn btn-primary mt-4 mb-4 ">
    <span class="fas fa-exchange-alt mr-3" aria-hidden="true"></span>
    TRASFERISCI
    <span v-if="bt_spinner2" class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
</button>

</div>


<div v-if="item.productId>0">

    <div class="form-group">
        <label for="exampleInput1">Articolo</label>
        <input :disabled="true" type="text" class="form-control" id="exampleInput1" v-model="description">
    </div>
    <div class="form-group">
        <label for="exampleInput1">Colore</label>
        <input :disabled="true" type="text" class="form-control" id="exampleInput1" v-model="item.color">
    </div>
    
    <div class="form-group">
        <label for="exampleInput1">Misura</label>
        <input :disabled="true" type="text" class="form-control" id="exampleInput1" v-model="item.size">
    </div>
    <div class="form-group">
        <label for="exampleInput1">Esistenza</label>
        <input v-bind:style="{  color: item.qtyStock <=0 ? 'red' :'black' }"  :disabled="true" type="text" class="form-control" id="exampleInput1" v-model="item.qtyStock">
    </div>
    
</div>    





</form>


  
  </div>
  </div>

 </div>

 </div>
 <confirm-box v-if="cb.show">
    <template v-slot:header>
      <strong>CONFERMI TRASFERIMENTO ?</strong>    
      </template>
      <template v-slot:body>
      </template>
      
    <template v-slot:footer>  
        <button @click="cb.show=false" type="button" class="btn btn-secondary">NO</button>
        <button @click="closeConfirmBox(),cb.show=false" type="button" class="btn btn-primary">SI</button>
    </template>    
    </confirm-box>


 <alert-box class="mt-2" @close="msg.title=''" v-bind:msg="msg"  ></alert-box>
  
</div>


</template>
<script>


import api               from '@/api'
import { mapGetters }    from 'vuex';
import alertBox          from '@/components/common/AlertBox.vue';
import confirmBox        from '@/components/common/ConfirmBox.vue';
import scanner           from '@/components/common/QuaggaScanner.vue'; 
import scannerDetection  from '@/scanner';  

//import {setFmtDate1} from './../../functions';   


export default {
  components: {alertBox,scanner,confirmBox},
  data() {
    return {
      
      item            : {},
      cerca           : {to_storeId:0},
     
      bt_spinner1     : false,
      bt_spinner2     : false,
      description     : '',
      
      msg             : {

        title     : '',
        body      : '',
        type      : 0

      },
      
      cb          : {
        show      : false
      }
           
    };
  },

  computed :{
    ...mapGetters(['storeId','company']),
   
  },
  directives: {
    focus: {
      // directive definition

      inserted : function(el) 
      {
        //el.focus();
      }

    }
  },
  mounted: function() {

  $(document).scannerDetection(data => 
    {
      onReceive:
      onComplete:
    
      if (data.length == 13)
      { 
       
          this.setBarcode(data)
  
      }

    });
    
  



  },
  created: function() {
    this.storeTostore(this.storeId)
  },
  methods: {
    setBarcode(barcode)
    {
        this.dataProduct(barcode)
    },  
    submit() 
    {

      
      this.msg.title = ''
      if(this.storeId == this.cerca.to_storeId)
      {
        
        
        this.msg.title = 'ATTENZIONE Provenienza e Destinazione devono essere diversi.'
        this.msg.body  = ''
        this.msg.type  = 1
        
        return
      }

      this.openConfirmBox()

      //this.smartMovement(this.item)

    },  
    openConfirmBox()
    {
       this.cb.show = true

       
    },
    closeConfirmBox()
    {
      this.smartMovement(this.item)
      
    },
    async storeTostore(Id)
    {
    
    this.msg.title = ''
    var sp        = {'sp':'spstoreTostore'}
    var data      = {'storeId' : Id} 
    var json      = Object.assign(data, sp)
    await api.post(json).then(res => {
        if(res.status==200)
          {
            if(res.data.recordsets[0].length==0)
            {
              return
            }
          
            this.cerca.to_storeId = res.data.recordsets[0][0]['storeId2']        

          }
          else if(res.status==500)
          {
       
            this.msg.title = 'ATTENZIONE '
            this.msg.body = res.data
            this.msg.type = 1

          } 
          else
          {
       
            this.msg.title = 'ATTENZIONE '
            this.msg.body = res
            this.msg.type = 1                 
          } 
      }).catch(err => 
      {
       
            this.msg.title = 'ATTENZIONE '
            this.msg.body = err.message
            this.msg.type = 1           

      }).finally(() => {
      //  this.spinner = false
      });  


        
    },


    async dataProduct(barcode)
    {
    
    this.item = {}
    
    

    this.msg.title = '' 
    this.bt_spinner1  = true
    var sp        = {'sp':'spDataProductByBarcode'}
    var data      = {'barcode' : barcode ,'storeId' : this.storeId} 
    var json      = Object.assign(data, sp)
    
    
    await api.post(json).then(res => {
        if(res.status==200)
          {
            if(res.data.recordsets[0].length==0)
          {
            this.msg.title = "ATTENZIONE "
            this.msg.body  = "PRODOTTO INESISTENTE."
            this.msg.type  = 1
            
            
            return
          }
          
          this.item = res.data.recordsets[0][0]
          this.description = this.item.category + ' ' + this.item.brand + ' ' + this.item.sku         
          }
          else if(res.status==500)
          {
            console.log(res.data)

          } 
          else
          {
            console.log('Network Error.')                  
          } 
      }).catch(err => 
      {
        console.log(err.message)    
      }).finally(() => {
        this.bt_spinner1 = false
      });

        
  
    },
   
    async smartMovement(item) {
     
 
     if(item.qtyStock <=0 )   
     {
            this.msg.title = "ATTENZIONE PRODOTTO NON DISPONIBILE."
            this.msg.body  = ''
            this.msg.type  = 1
            
            return
     }
     this.bt_spinner2 = true
     

     var data     = {}
      
     data.header  = {}
     data.body    = []
      
     data.header.companyId     = this.company.Id
     data.header.senderId      = this.storeId
     data.header.storeId       = this.cerca.to_storeId    

     data.body.push({'productId':item.productId,'barcode':item.barcode,'cost_price':item.cost_price})      
     
     
     const sp     = {'sp':'spCreateMovementToStoreNew'}
          
     const json   = Object.assign(data, sp);
     await api.post(json).then(res => {
	    if(res.status==200)
        {
          this.item = {}
          this.msg.title = "TRASFERIMENTO EFFETTUATO."
          this.msg.body  = ""
          this.msg.type  = 0

            const store         = res.data.recordsets[0][0].store
            const d             = new Date()
            const date          = d.toLocaleString()       
            const senderId      = this.storeId            
            const data          = date            
            const descrizione1  = store                        
            api.postMsg({"date" : data,
            
                         "description1" : descrizione1, 
                         "description2" : '',  
                         "shippedFrom"  : senderId,
                         'shippedTo'    : this.cerca.to_storeId ,
                         'rowId'        : Math.random() * this.storeId,
                         'total_qty'    : res.data.recordsets[0][0].total_qty
                        })  
       




          
        }
        else if(res.status==500)
        {
          
          this.msg.title = 'ATTENZIONE '
          this.msg.body  = res.data
          this.msg.type  = 1
          
        } 
        else
        {
          
          this.msg.title = 'ATTENZIONE '
          this.msg.body  = res
          this.msg.type  = 1
          
        } 
    }).catch(err => 
    {
      
          this.msg.title = 'ATTENZIONE '
          this.msg.body  = err.message
          this.msg.type  = 1   
    }).finally(() => {
      this.item = {}
      this.bt_spinner2 = false
    });
     

        

    },

}

    
}
</script>
<style scoped>

h4 {
  font-family  : 'Roboto Condensed';
  font-size    : 20px;
}
.card-header
{
  height: 45px;
}
</style>